import { render, staticRenderFns } from "./warn_record_activity_list.vue?vue&type=template&id=b0fb48d2&scoped=true"
import script from "./warn_record_activity_list.vue?vue&type=script&lang=js"
export * from "./warn_record_activity_list.vue?vue&type=script&lang=js"
import style0 from "./warn_record_activity_list.vue?vue&type=style&index=0&id=b0fb48d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fb48d2",
  null
  
)

export default component.exports